import tw from "twin.macro";

const Card = tw.div`max-w-xl w-full bg-white p-16 rounded-lg shadow-mevia`;

export default Card;
